import { ShipmentListTab, type ShipmentListTabDefinition } from './types';

export const DEFAULT_SHIPMENT_LIST_TAB: ShipmentListTab = ShipmentListTab.ALL_SHIPMENTS;

export const shipmentListTabs: ShipmentListTabDefinition[] = [
  { label: 'All shipments', tab: ShipmentListTab.ALL_SHIPMENTS },
  { label: 'Tracked road shipments', tab: ShipmentListTab.TRACKED_SHIPMENTS },
  { label: 'Consolidations', tab: ShipmentListTab.CONSOLIDATIONS }
];
